/* eslint-disable react/no-danger */
import React from 'react';
import { isEmpty, map } from 'lodash';
import { Link } from 'gatsby';
import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export default function FreeZoneApplicationProcess({ data, id }) {
  const { title, text, items, disclaimer, link, backgroundImage } = data;
  return (
    <section id={id} className="relative overflow-hidden">
      <div
        className="max-w-[1632px] mx-auto py-[50px] md:py-[100px] px-6 md:px-4 flex flex-col
      gap-y-10 z-10 relative">
        <div className="flex flex-col gap-y-5 lg:gap-y-[30px]">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.4 }}
            viewport={{ once: true }}
            className="flex flex-col gap-y-5">
            <div
              dangerouslySetInnerHTML={{ __html: title }}
              className="text-clamp20to40  h2-child:text-clamp20to40 text-[#4A4A4A]
            h2-child:leading-1.2 text-center h2-child:!m-0"
            />
            <div className="h-[2px] w-[50px] md:w-[70px] bg-[#CE445B] mx-auto" />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.5 }}
            viewport={{ once: true }}
            dangerouslySetInnerHTML={{ __html: text }}
            className="p-child:text-[#4A4A4A] p-child:text-clamp12to18 p-child:font-normal
            p-child:leading-[1.6] p-child:mb-0 
            p-child:ltr:font-URWDINRegular 
            p-child:rtl:font-GESSTwoDWTCLight 
            text-center"
          />
          {isEmpty(items) || (
            <div
              className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 
            gap-7 md:gap-8 pt-[10px] justify-center">
              {map(items, (item, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.3 * (index + 1), delay: 0.6 }}
                  className="flex flex-col gap-y-3 md:gap-y-5 xl:gap-y-6
                  [&>.icon-box]:before:content['']
                  [&:not(:last-child)>.icon-box]:before:md:border-y-8
                  [&>.icon-box]:before:md:border-y-transparent
                  [&:not(:last-child)>.icon-box]:before:border-x-8
                  [&:not(:last-child)>.icon-box]:before:md:border-r-[0px]
                  [&>.icon-box]:before:md:border-l-[12px]
                  [&>.icon-box]:before:border-l-transparent
                  [&>.icon-box]:before:border-r-transparent
                  [&>.icon-box]:before:md:border-l-[#CE435B]
                  [&>.icon-box]:before:absolute [&>.icon-box]:before:md:rtl:scale-[-1]
                  [&>.icon-box]:before:md:ltr:left-full [&>.icon-box]:before:md:rtl:right-full
                  [&>.icon-box]:before:border-t-[12px] [&>.icon-box]:before:md:border-t-0
                  [&>.icon-box]:before:border-t-[#CE435B]
                  [&>.icon-box]:before:top-full [&>.icon-box]:before:md:top-auto">
                  <div
                    className="w-[50px] h-[50px] bg-[#CE435B] flex justify-center items-center 
                    mx-auto md:mx-0 relative icon-box text-white 
                    ltr:font-LibreBaskervilleRegular 
                    rtl:font-GESSTwoDWTCMedium
                    text-clamp20to25">
                    {/* {isEmpty(item.content.applicationProcessIcon) || (
                      <LazyLoadImage
                        src={item.content.applicationProcessIcon.url}
                        alt={title}
                        className="w-[24px] h-[24px] object-cover"
                      />
                    )} */}
                    {index + 1}
                  </div>
                  <div
                    dangerouslySetInnerHTML={{ __html: item.content.applicationProcessTitle }}
                    className="p-child:text-[#4A4A4A] p-child:text-clamp15to18 p-child:font-normal
                      child:leading-[1.6] child:mb-0 child:font-DINMedium text-center
                      ltr:md:text-left rtl:md:text-right pt-[10px] md:pt-0 br-break:md:block
                      br-break:hidden rtl:md:min-h-[52px] rtl:xl:min-h-[82px]"
                  />
                  <div
                    dangerouslySetInnerHTML={{ __html: item.content.applicationProcessText }}
                    className="p-child:text-[#4A4A4A] p-child:text-clamp12to15 p-child:font-normal
                      p-child:leading-[1.6] p-child:mb-0 
                      p-child:ltr:font-URWDINRegular 
                      p-child:rtl:font-GESSTwoDWTCLight 
                      flex flex-col
                      gap-y-3 md:gap-y-5 text-center ltr:md:text-left rtl:md:text-right"
                  />
                </motion.div>
              ))}
            </div>
          )}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.7 }}
            viewport={{ once: true }}
            dangerouslySetInnerHTML={{ __html: disclaimer }}
            className="p-child:text-[#4D4D4D] p-child:text-clamp12to15 p-child:font-normal
            p-child:leading-[1.6] p-child:mb-0 
            p-child:ltr:font-URWDINRegular 
            p-child:rtl:font-GESSTwoDWTCLight 
            text-center max-w-[971px]
            mx-auto p-strong:font-DINMedium pt-[10px] md:pt-0"
          />
          {isEmpty(link) || (
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.8 }}
              viewport={{ once: true }}
              className="flex justify-center pt-[10px] md:pt-0">
              <Link
                href={link.url}
                className="application-process-get-started-cta w-fit flex 
                justify-center items-center rounded-[48px]
                bg-[#CE445B] text-white uppercase px-12 md:px-14
                ltr:font-URWDINBold rtl:font-GESSTwoDWTCMedium ltr:tracking-[0.96px]
                leading-[36px] md:leading-1.25 min-h-10 md:h-[50px] text-[11px] md:text-[15px]
                text-center py-0 md:py-5 pt-1 md:pt-6 hover:bg-[#B53B50] rtl:tracking-[0px]">
                {link.name}
              </Link>
            </motion.div>
          )}
        </div>
      </div>
      {isEmpty(backgroundImage) || (
        <div
          className="w-full h-full absolute bottom-0 lazy-load-image:flex
        lazy-load-image:h-full">
          <LazyLoadImage
            src={backgroundImage.url}
            width="100%"
            effect="blur"
            placeholderSrc={`${backgroundImage}`}
            className="w-full h-full object-cover"
          />
        </div>
      )}
    </section>
  );
}
